// 处理url
let model = {};

let search = window.location.search || '';

search= search.slice(1);

let entries = search.split('&');
entries.forEach(item=>{
    let entry = item.split('=');
    model[entry[0]] = decodeURIComponent(entry[1]);
})

export default model;


// WEBPACK FOOTER //
// ./src/assets/model.js